export class Interactive {
    _id = '';
    is_post = false;//đăng bài
    is_post_personal = false;
    groups_is_post = Array();
    content_post = '';
    time_before_post_from = 2;
    time_before_post_to = 5;

    time_after_content_post_from = 2;
    time_after_content_post_to = 4;

    time_after_post_from = 2;
    time_after_post_to = 4;

    is_join_group = false;
    max_group = 1;
    is_join_1_group = false;//cho phép tham gia cùng 1 nhóm
    groups_is_join = Array();
    content_replys = Array();

    time_before_join_from = 2;
    time_before_join_to = 5;

    time_after_content_join_from = 2;
    time_after_content_join_to = 4;

    time_after_join_from = 2;
    time_after_join_to = 4;
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_models/auto_seeding/interactive.ts